import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";
import Stats from "./Stats";

const BoxBreakStats = ({ analyticsData }) => {
  const navigate = useNavigate();
  const bb = analyticsData?.box_break;

  const statusStats = [
    {
      label: "Active",
      description: "Box breaks currently active.",
      value: bb?.total_box_break_active || 0,
      key: "active",
      color: "#10B981",
    },
    {
      label: "Sold Out",
      description: "Box breaks that are sold out.",
      value: bb?.total_box_break_sold_out || 0,
      key: "sold_out",
      color: "#E11D48",
    },
    {
      label: "Scheduled",
      description: "Box breaks scheduled to go live.",
      value: bb?.total_box_break_scheduled || 0,
      key: "stream_scheduled",
      color: "#3B82F6",
    },
    {
      label: "Live",
      description: "Box breaks currently live.",
      value: bb?.total_box_break_live || 0,
      key: "live",
      color: "#F97316",
    },
    {
      label: "Completed",
      description: "Box breaks that have completed.",
      value: bb?.total_box_break_completed || 0,
      key: "completed",
      color: "#16A34A",
    },
    {
      label: "Closed",
      description: "Box breaks that have been closed.",
      value: bb?.total_box_break_closed || 0,
      color: "#8B5CF6",
    },
    {
      label: "Paid Orders",
      description: "Orders that have been paid for.",
      value: bb?.total_box_break_paid_orders || 0,
      color: "#0EA5E9",
    },
    {
      label: "Categories Sold",
      description: "Categories that have sold.",
      value: bb?.total_box_break_categories_sold || 0,
      color: "#0d6efd",
    },
    {
      label: "Categories Won",
      description: "Categories that have been won.",
      value: bb?.total_box_break_categories_won || 0,
      color: "#EF4444",
    },
    {
      label: "Categories Lost",
      description: "Categories that have been lost.",
      value: bb?.total_box_break_categories_lost || 0,
      color: "#7C3AED",
    },
  ];

  return (
    <div className="dashboard-section mb-4">
      <h4 className="section-title mb-4">Box Break Analytics</h4>

      {/* Status breakdown cards */}
      <div className="row g-4">
        {statusStats.map((item, index) => (
          <div
            className={`col-12 col-md-6 col-lg-3 ${
              item?.key ? "cursor-pointer" : ""
            }`}
            key={index}
            onClick={() =>
              item?.key ? navigate(`/broken-cards?search=${item.key}`) : ""
            }
          >
            <div
              className="analytics-card"
              style={{ borderLeft: `5px solid ${item.color}` }}
            >
              <p className="mb-1 fw-semibold">{item.label}</p>
              <small
                className="text-muted d-block mb-3"
                style={{
                  fontSize: "12px",
                  minHeight: "34px",
                  lineHeight: "1.35",
                }}
              >
                {item.description}
              </small>
              <h3>
                <CountUp end={Number(item.value)} duration={2} />
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoxBreakStats;
